import { useState, useEffect } from 'react';
import { FormattedMessage, useIntl } from 'react-intl';
import { DropdownOption, InputSize } from 'components/Dropdown/types';
import { useAppSelector } from 'store/hooks';
import { getArchiveOnly } from '../slice';
import { getAllPrinterErrors } from './slice';
import { StyledCheckTrayDropdown } from './styled';
import { CheckSequenceCheckTrayType } from './types';

export const CheckSequenceCheckTrayDropdown = ({
  checkTrayValue,
  setSelectedCheckTray,
  isLoading,
  defaultOption
}: CheckSequenceCheckTrayType): React.JSX.Element => {
  const intl = useIntl();
  const [checkTray, setCheckTray] = useState<DropdownOption>();

  const printerErrors = useAppSelector(getAllPrinterErrors);
  const disabled = useAppSelector(getArchiveOnly);
  const handleCheckTray = (selectedValue: DropdownOption) => {
    setCheckTray(selectedValue);
    setSelectedCheckTray(selectedValue);
  };

  useEffect(() => {
    if (defaultOption) {
      setCheckTray(defaultOption);
      setSelectedCheckTray(defaultOption);
    }
  }, [defaultOption, intl, setSelectedCheckTray]);

  return (
    <StyledCheckTrayDropdown
      isLoading={isLoading}
      inputId="checkSequenceCheckTray"
      dataTestId="checkSequenceCheckTray"
      label={
        <FormattedMessage
          description="Label for Printer dropdown"
          defaultMessage="CheckTray"
        />
      }
      placeHolder={intl.formatMessage({
        description: 'Place holder message for CheckTray',
        defaultMessage: 'Select'
      })}
      onChange={handleCheckTray}
      options={checkTrayValue || []}
      value={checkTray}
      isDisabled={disabled}
      size={InputSize.STANDARD}
      isRequired
      errorMessage={
        <FormattedMessage
          description="Label for select a CheckTray Dropdown"
          defaultMessage="Required"
        />
      }
      hasError={printerErrors.checkTrayError}
      enableCustomValidation
    />
  );
};
